import { PensionPlanTransfer } from '../../api/pension-plan-transfers/interfaces/PensionPlanTransfer';

/** Un traspaso tarda entre 15 y 30 días: el progreso se mide contra el máximo. */
export const PLAZO_MAXIMO_DIAS = 30;
const MS_DIA = 24 * 60 * 60 * 1000;

export interface ProgresoTraspaso {
	/** Días completos desde que se pidió. */
	dia: number;
	/** 0-100, contra los 30 días. */
	progressPct: number;
	/** Llegada estimada: el final del plazo. */
	eta: Date;
	/** Han pasado más de 30 días. */
	fueraDePlazo: boolean;
}

/**
 * En qué punto del plazo de 15-30 días va un traspaso (product#6, §3.3). Cuenta desde que arrancó
 * el proceso (`processStarted`, como el timeline de Inicio) o, si no se sabe, desde que se pidió: en
 * el funnel `createdAt` puede ser semanas antes de la STDE.
 */
export function buildTransferProgress(transfer: PensionPlanTransfer, hoy: Date): ProgresoTraspaso {
	const alta = new Date(transfer.processStarted ?? transfer.createdAt).getTime();
	const dia = Math.max(0, Math.floor((hoy.getTime() - alta) / MS_DIA));
	return {
		dia,
		progressPct: Math.min(100, Math.round((dia / PLAZO_MAXIMO_DIAS) * 100)),
		eta: new Date(alta + PLAZO_MAXIMO_DIAS * MS_DIA),
		fueraDePlazo: dia > PLAZO_MAXIMO_DIAS
	};
}
